// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qp0eA {\n    display: flex;\n    align-items: center;\n    grid-gap: var(--xs);\n    gap: var(--xs);\n  }\n\n    .qp0eA .bp3-button {\n      padding: 0;\n    }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ZoomBarV2_zoomButtonsWrapper": "qp0eA"
};
export default ___CSS_LOADER_EXPORT___;
